<template>
	<div id="app">
		<router-view :key="routeKey"></router-view>
		<!-- <Index ref="index"></Index> -->
		<Login v-if="$store.state.isShowLogin"></Login>
		<div class="loading_wrap" v-if="$store.state.isShowLoading">
			<div class="loading" v-if="$store.state.isShowLoadingImg"></div>
		</div>
	</div>
</template>

<script>
import Login from "./components/Login.vue";
import { mapActions } from "vuex";

export default {
	name: "app",
	components: {
		Login: Login
	},
	data: function() {
		return {
			routeKey: 1
		};
	},
	methods: {
		...mapActions(["sendUserlog", "getLogin", "getDevUser", "getPid"]),
		init: function() {
			let url = window.location.href;
			if (url.indexOf("/qh") > -1) {
				this.$store.state.router.type = "nas";
				this.$store.state.router.appid = "owdl";
				this.$store.state.router.chanid = "qunhui";
			} else if (url.indexOf("/tos") > -1) {
				this.$store.state.router.type = "nas";
				this.$store.state.router.appid = "TosNas";
			} else if (url.indexOf("/ott") > -1) {
				this.$store.state.router.type = "ott";
				this.$store.state.router.appid = "ott";
			}

			// test
			// this.$store.state.router.type = "ott";

			if (this.$store.state.router.appid) {
				localStorage.setItem("appid", this.$store.state.router.appid);
			}
			if (this.$store.state.router.chanid) {
				localStorage.setItem("chanid", this.$store.state.router.chanid);
			}
			if (this.$store.state.router.refuid) {
				localStorage.setItem("refuid", this.$store.state.router.refuid);
			}
		},
		initDesc: function() {
			let url = window.location.href;

			let isDesc = localStorage.getItem("kd-isDesc");
			// console.log("isDesc" + isDesc);

			// 登陆或者登陆中不跳转
			if (isDesc || this.$store.state.isLogin || this.$route.query.code) {
				return;
			}

			if (url.indexOf("/qh") > -1) {
				localStorage.setItem("kd-isDesc", 1);
				this.$router.push({ path: "/desc" });
			}
			// test
			// this.$router.push({ path: "/desc" });
		},
		hideQrcode: function() {
			this.$store.state.isShowQrcode = false;
		},
		refreshRouteView: function() {
			this.routeKey = new Date().getTime();
		},
		checkLogin: function() {
			let uid = localStorage.getItem("kd2-uid");
			let openid = localStorage.getItem("kd2-openid");
			let nickname = localStorage.getItem("kd2-nickname");
			let headimg = localStorage.getItem("kd2-headimg");

			// 记住用户来源信息
			let appid = this.$route.query.appid;
			let buid = this.$route.query.buid;
			let chanid = this.$route.query.chanid;
			let refuid = this.$route.query.refuid;

			if (appid == "qh360") {
				appid = "QH360V5SRT";
			}

			if (appid == "QH360V5SRT") {
				this.$router.push({ path: "/pc360" });
				return;
			}

			if (appid == "QH360V5SRT" || appid == "ToToLink") {
				localStorage.setItem("appid", appid);
				this.$store.state.router.appid = appid;
				// this.initWithPid(this.$route.query.pid);
				let sn = this.$route.query.sn ? this.$route.query.sn : "";
				let mac = this.$route.query.mac ? this.$route.query.mac : "";
				this.initWithSnAndMac(sn, mac);
				return;
			}

			if (appid) {
				localStorage.setItem("appid", appid);
				this.$store.state.router.appid = appid;
			} else {
				appid = localStorage.getItem("appid");
				this.$store.state.router.appid = appid ? appid : "";
			}
			if (buid) {
				localStorage.setItem("buid", buid);
				this.$store.state.router.buid = buid;
			} else {
				buid = localStorage.getItem("buid");
				this.$store.state.router.buid = buid ? buid : "";
			}
			if (chanid) {
				localStorage.setItem("chanid", chanid);
				this.$store.state.router.chanid = chanid;
			} else {
				chanid = localStorage.getItem("chanid");
				this.$store.state.router.chanid = chanid ? chanid : "";
			}

			if (localStorage.getItem("refuid")) {
				refuid = localStorage.getItem("refuid");
				this.$store.state.router.refuid = refuid ? refuid : "";
			} else if (refuid) {
				localStorage.setItem("refuid", refuid);
				this.$store.state.router.refuid = refuid;
			}

			if (uid) {
				this.$store.state.user.uid = uid;
				this.$store.state.user.openid = openid;
				this.$store.state.user.nickname = nickname;
				this.$store.state.user.headimg = headimg;
				if (openid) {
					this.$store.state.isLogin = true;
				}
			} else {
				this.$store.state.user.uid =
					parseInt(Math.random() * 100000000) + "";
				localStorage.setItem("kd2-uid", this.$store.state.user.uid);
			}
		},
		initWithPid: function(pid) {
			// console.log("initWithPid", pid);
			let _that = this;
			pid = decodeURIComponent(pid);
			if (pid) {
				// console.log(pid);
				_that.$store.state.localPid = pid;
				_that.$store.state.bindPid = pid;
				localStorage.setItem("kd2-pid", pid);
				_that.getDevUser([
					pid,
					function(err, data) {
						_that.$store.state.user.nickname =
							_that.$store.state.user.uid;
						_that.$store.state.isLogin = true;
						_that.refreshRouteView();
					}
				]);
			} else {
				// _that.randLogin();
				_that.$toast("获取设备信息失败，请检查网络");
			}
		},
		initWithSnAndMac: function(sn, mac) {
			let _that = this;
			sn = decodeURIComponent(sn).toUpperCase();
			let pid = "";
			mac = mac ? mac : "";
			mac = decodeURIComponent(mac);
			mac = mac.replace(/:/g, "").toUpperCase();
			if (sn || mac) {
				_that.getPid([
					sn,
					mac,
					function(err, data) {
						if (!err && data.pid) {
							pid = data.pid;
						} else {
							_that.$toast("获取用户信息失败，请检查网络");
							return;
						}
						// console.log(err);
						// console.log(data);
						_that.$store.state.localPid = pid;
						_that.$store.state.bindPid = pid;
						localStorage.setItem("kd2-sn", sn);
						_that.getDevUser([
							pid,
							function(err, data) {
								_that.$store.state.user.nickname =
									_that.$store.state.user.uid;
								_that.$store.state.isLogin = true;
								_that.refreshRouteView();
							}
						]);
					}
				]);
			} else {
				// _that.randLogin();
				_that.$toast("获取设备信息失败，请检查网络");
			}
		},
		checkSystem: function() {
			let u = navigator.userAgent;
			let isAndroid =
				u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //安卓
			let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			if (isAndroid) {
				this.$store.state.system = "android";
			} else if (isIOS) {
				this.$store.state.system = "ios";
			} else {
				this.$store.state.system = "other";
			}
		},
		initTryInfo: function() {
			let timestamp = parseInt(new Date().getTime() / 1000);

			this.$store.state.upTryTimestamp = parseInt(
				localStorage.getItem("kd-upTryTimestamp")
					? localStorage.getItem("kd-upTryTimestamp")
					: 0
			);

			if (timestamp < this.$store.state.upTryTimestamp) {
				this.$store.state.isUpTry = true;
				this.$store.state.isSupportUp = true;
				this.$store.state.upTryLeft =
					this.$store.state.upTryTimestamp - timestamp;
				// console.log(this.$store.state.upTryLeft);
			} else if (this.$store.state.upTryTimestamp > 0) {
				this.$store.state.isUpTryEnd = true;
				this.$store.state.isSupportUp = true;
				localStorage.setItem("kd-upTryTimestamp", 0);
			}

			this.$store.state.downTryTimestamp = parseInt(
				localStorage.getItem("kd-downTryTimestamp")
					? localStorage.getItem("kd-downTryTimestamp")
					: 0
			);
			if (timestamp < this.$store.state.downTryTimestamp) {
				this.$store.state.isDownTry = true;
				this.$store.state.isSupportDown = true;
				this.$store.state.downTryLeft =
					this.$store.state.downTryTimestamp - timestamp;
			} else if (this.$store.state.downTryTimestamp > 0) {
				this.$store.state.isDownTryEnd = true;
				this.$store.state.isSupportDown = true;
				localStorage.setItem("kd-downTryTimestamp", 0);
			}
		},
		initAction: function() {
			let _that = this;
			let action = this.$route.query.action;
			if (action == "qrcode") {
				// let isShowQrcode = parseInt(
				// 	localStorage.getItem("kd-isShowQrcode")
				// 		? localStorage.getItem("kd-isShowQrcode")
				// 		: 0
				// );
				// if (!isShowQrcode) {
				// 	_that.$store.state.isShowQrcode = true;
				// 	localStorage.setItem("kd-isShowQrcode", 1);
				// }
			} else if (action == "pay_up") {
				_that.$store.state.payType = "up";
				_that.$store.state.isShowPay = true;
			} else if (action == "pay_down") {
				_that.$store.state.payType = "down";
				_that.$store.state.isShowPay = true;
			}

			let code = this.$route.query.code;
			if (code) {
				_that.$store.state.isShowLoading = true;
				let buid = localStorage.getItem("buid");
				buid = buid ? buid : "";
				let tuid = buid;
				let appid = localStorage.getItem("appid");
				appid = appid ? appid : "";
				let chanid = localStorage.getItem("chanid");
				chanid = chanid ? chanid : "";
				let refuid = localStorage.getItem("refuid");
				refuid = refuid ? refuid : "";
				_that.getLogin([
					code,
					tuid,
					buid,
					appid,
					chanid,
					refuid,
					function(err, data) {
						// console.log("login");
						// console.log(data);
						_that.$store.state.isShowLoading = false;
					}
				]);
			}
		},
		initGuide: function() {
			let isHideGuide = localStorage.getItem("kd-isHideGuide");
			if (isHideGuide == 1) {
				this.$store.state.isShowGuide = false;
			} else {
				this.$store.state.isShowGuide = true;
			}
		},
		initViewport: function() {
			let viewport = document.querySelector("meta[name=viewport]");
			let winWidths = window.visualViewport.width;
			if (winWidths >= 1920) {
				viewport.setAttribute(
					"content",
					"width=1920, user-scalable=no"
				);
			} else if (winWidths >= 1440) {
				viewport.setAttribute(
					"content",
					"width=1440, user-scalable=no"
				);
			} else {
				viewport.setAttribute(
					"content",
					"width=1280, user-scalable=no"
				);
			}
		}
	},
	beforeMount: function() {
		let _that = this;
		_that.checkLogin();
		_that.init();
		_that.initAction();
		_that.checkSystem();
		_that.initGuide();
		// _that.initDesc();
		// _that.initViewport();
		_that.sendUserlog(["open", document.location.href]);
	},
	mounted: function() {
		let _that = this;
		_that.initTryInfo();
	}
};
</script>

<style>
* {
	margin: 0;
	padding: 0;
	border: 0;
}

html {
	font-family: PingfangSC, Microsoft YaHei, Arial, sans-serif;
}

html,
body,
#app {
	width: 100%;
	height: 100%;
	background-color: #020716;
	overflow: hidden;
}

a {
	text-decoration: none;
}

.loading_wrap {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 99;
}

.loading {
	width: 30px;
	height: 30px;
	border: 3px solid #fff;
	border-top-color: transparent;
	border-radius: 50%;
	animation: rotate 1s linear infinite;
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -15px;
	margin-top: -15px;
}

@keyframes rotate {
	from {
		-webkit-transform: rotate(0);
	}

	to {
		-webkit-transform: rotate(360deg);
	}
}
</style>
